import React, { Suspense, useEffect, useState } from 'react';
const ResultModal = React.lazy(
  () => import('../../../Components/Modal/ResultModal.component')
);
const CourseMainInputs = React.lazy(
  () => import('../../../Components/CourseForm/CourseMainInputs')
);
const CourseSecondaryInputs = React.lazy(
  () => import('../../../Components/CourseForm/CourseSecondaryInputs')
);
const CourseThirdInputs = React.lazy(
  () => import('../../../Components/CourseForm/CourseThirdInputs')
);
const EditCourseSubmit = React.lazy(
  () => import('./CourseEditSubmit.component')
);
const PageScroller = React.lazy(
  () => import('../../../Components/PageScroller/PageScroller.component')
);
const CopyCourse = React.lazy(() => import('./CopyCourse.component'));
import { format } from 'date-fns';
import PropTypes from 'prop-types';

const CourseEditInnerComponent = ({ c, id }) => {
  const [fullCourse, setFullCourse] = useState([]);
  const [course, setCourse] = useState({
    courseName: '',
    description: '',
    notes: '',
    price: 25,
    expiryDate: 0,
    certificatePrefix: '',
    active: false,
    partTwo: false,
  });
  const [tags, setTags] = useState([]);
  const [image, setImage] = useState('');
  const [questions, setQuestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [successState, setSuccessState] = useState('');
  const [pdf, setPdf] = useState(null);
  const [video, setVideo] = useState('');
  const [videoLinks, setVideoLinks] = useState([]);
  const [att, setAtt] = useState([]);

  useEffect(() => {
    setFullCourse(c);
    setCourse({
      courseName: c?.courseName || '',
      description: c?.description || '',
      notes: c?.notes || '',
      price: c?.price || 25,
      expiryDate: c?.expiryDate || 0,
      certificatePrefix: c?.certificatePrefix || '',
      active: c?.active || false,
      partTwo: c?.partTwo || false,
    });
    setTags(c?.tags || []);
    setQuestions(c?.quiz || []);
    setImage(c?.image || '');
    setPdf(c?.pdf || null);
    setVideo(c?.video || '');
    setVideoLinks(c?.videoLinks || []);
    setAtt(c?.attachments || []);
  }, [id, c]);

  const formattedCreatedAt = fullCourse?.createdAt
    ? format(new Date(fullCourse?.createdAt), 'MMMM dd yyyy,  HH:mm')
    : '';
  const formattedUpdatedAt = fullCourse?.updatedAt
    ? format(new Date(fullCourse?.updatedAt), 'MMMM dd yyyy,  HH:mm')
    : '';
  return (
    <>
      <span className="italicSpan">
        Current Certificate Count: {fullCourse?.certificateCount}
      </span>
      <span className="italicSpan">
        Purchase Count: {fullCourse?.purchasedCount}
      </span>
      <span className="italicSpan">Created At: {formattedCreatedAt}</span>
      <span className="italicSpan">Last Edited At: {formattedUpdatedAt}</span>
      <form>
        <h3>Main Information</h3>
        <Suspense fallback={<p>Loading main inputs...</p>}>
          <CourseMainInputs course={course} setCourse={setCourse} />
        </Suspense>
        <Suspense fallback={<p>Loading secondary inputs...</p>}>
          <CourseSecondaryInputs
            att={att}
            setAtt={setAtt}
            videoLinks={videoLinks}
            setVideoLinks={setVideoLinks}
            video={video}
            setVideo={setVideo}
            pdf={pdf}
            setPdf={setPdf}
            image={image}
            setImage={setImage}
          />
        </Suspense>
        <Suspense fallback={<p>Loading third inputs...</p>}>
          <CourseThirdInputs
            tags={tags}
            setTags={setTags}
            questions={questions}
            setQuestions={setQuestions}
          />
        </Suspense>
        <Suspense fallback={<p>Loading copy course...</p>}>
          <CopyCourse id={id} />
        </Suspense>
        <Suspense fallback={<p>Loading result modal...</p>}>
          <ResultModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            result={successState}
            linkTo="/admin"
          />
        </Suspense>
        <Suspense fallback={<p>Loading page scroller...</p>}>
          <PageScroller />
        </Suspense>
        <Suspense fallback={<p>Loading submit button...</p>}>
          <EditCourseSubmit
            course={course}
            pdf={pdf}
            videoLinks={videoLinks}
            questions={questions}
            tags={tags}
            image={image}
            setIsOpen={setIsOpen}
            successState={successState}
            setSuccessState={setSuccessState}
            att={att}
          />
        </Suspense>
      </form>
    </>
  );
};
CourseEditInnerComponent.propTypes = {
  c: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CourseEditInnerComponent;
